export const ZhChsOutOfOfficeStrings = {
  UPDATE_SUCCESS_MSG: "不在办公室 时间表已更新",
  DELETE_SUCCESS_MSG: "不在办公室 时间表已移除",

  OUT_OF_OFFICE_UNTIL: "不在办公室直到 "
};
